import React from 'react'
import twistLogo from "../../assets/img/twist-logo.png"
import etisalteLogo from "../../assets/img/transparentLogo.png"
import { useTranslation } from "react-i18next"
import { Link, useLocation } from 'react-router-dom'
import TwistSettings from '../../TwistSettings.json'

const ErrorPage = ({ error }) => {
    const { t } = useTranslation()
    const { pathname } = useLocation()
    return (
        <div className='row p-0' style={{ height: "400px", width: "100%" }} data-testid="player-error-message">
            <div className='col-3 p-0'></div>
            <div className='col-6 p-0 d-flex flex-column justify-content-center mt-0' style={{ height: "100%" }}>
                <img src={TwistSettings["twist-ui"] ? twistLogo : etisalteLogo} width="100%" height="60%" alt="logo"></img>
                <div className='text-center fs-lg white-color'>{error}</div>
                <div className='text-light text-center fs-lg btn-link'><Link to={{ pathname: '/', state: { previousPathname: pathname } }}>اضغط هنا للعوده للرئيسيه</Link></div>
            </div>
            <div className='col-3 p-0'></div>
        </div>
    )
}

export default ErrorPage